import HttpService from '@/services/http/http.service';
import {
    ContentPageViewModel,
    CreateContentPageRequest,
    GenericViewModel,
    SaveBlocksRequest,
    SaveContentPageRequest
} from '@/types/apiServerContract';

const API_PATH = 'content/';

export class ContentApi {
    public static async GetContent(url: string): Promise<ContentPageViewModel> {
        return HttpService.Get<ContentPageViewModel>(API_PATH + 'GetContent', {
            url
        });
    }

    public static async GetContents(): Promise<ContentPageViewModel[]> {
        return HttpService.Get<ContentPageViewModel[]>(API_PATH + 'GetContents');
    }

    public static async CreateContentPage(request: CreateContentPageRequest): Promise<ContentPageViewModel> {
        return HttpService.Post<ContentPageViewModel>(API_PATH + 'CreateContentPage', request);
    }

    public static async DeleteContentPage(url: string): Promise<GenericViewModel<boolean>> {
        return HttpService.Get<GenericViewModel<boolean>>(API_PATH + 'DeleteContentPage', {
            url
        });
    }

    public static async SaveContentPage(request: SaveContentPageRequest): Promise<ContentPageViewModel> {
        return HttpService.Post<ContentPageViewModel>(API_PATH + 'SaveContentPage', request);
    }

    public static async SaveBlocks(request: SaveBlocksRequest): Promise<ContentPageViewModel> {
        return HttpService.Post<ContentPageViewModel>(API_PATH + 'SaveBlocks', request);
    }
}
